module.exports = __webpack_public_path__ + "img/menu-yiqi.f3192bde.svg";